import { LegacyPathRedirect } from "src/components/LegacyPathRedirect";

const Page = () => {
  return <LegacyPathRedirect />;
};

export default Page;
